import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {PearlHarbor} from "../../PearlHarbor";
import {PearlHarborGameMode} from "../../server/PearlHarborGameMode";
import {TimelineLite} from "gsap";
import {SimplePresentation, SimplePresentationRunner} from "../../../core/winpresentation/SimplePresentationRunner";
import {PearlHarborTotalWinRunner} from "../../presentationRunners/maingame/PearlHarborTotalWinRunner";
import {PearlHarborScatterWinRunner} from "../../presentationRunners/maingame/PearlHarborScatterWinRunner";
import {PearlHarborWinCapPresentation} from "../../presentationRunners/PearlHarborWinCapPresentation";
import {PearlHarborBigWinRunner} from "../../presentationRunners/PearlHarborBigWinRunner";
import {PearlHarborHelper} from "../../utils/PearlHarborHelper";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {PearlHarborFSIntroPresentation} from "../../presentationRunners/freespin/PearlHarborFSIntroPresentation";
import {PearlHarborXSWinRunner} from "../../presentationRunners/maingame/PearlHarborXSWinRunner";
import {PearlHarborBombWinRunner} from "../../presentationRunners/maingame/PearlHarborBombWinRunner";
import {
    PearlHarborResizeArea
} from "../../presentationRunners/maingame/PearlHarborResizeArea";

export class PearlHarborWinPresentation implements FlowStatePresentation {

    private _presentations: SimplePresentation[];

    constructor() {
        this._presentations = [
            new PearlHarborResizeArea(),
            new PearlHarborXSWinRunner(),
            new PearlHarborBombWinRunner(),
            new PearlHarborTotalWinRunner(),
            new PearlHarborBigWinRunner(),
            new PearlHarborScatterWinRunner(),
            new PearlHarborWinCapPresentation(),
            new PearlHarborFSIntroPresentation()
        ];
    }

    private onComplete(flowStateController: FlowStateController): void {
        const tl: TimelineLite = new TimelineLite();
        if (PearlHarbor.foregroundElements.boostedBet && PearlHarbor.model.data.nextMode == PearlHarborGameMode.NORMAL) {
            PearlHarbor.foregroundElements.startAnimationOnIdle();
        }
        // FreeSpin intro
        if (PearlHarbor.model.data.mode == PearlHarborGameMode.NORMAL && PearlHarborHelper.isFreeSpin(PearlHarbor.model.data.nextMode)) {
            tl.to(this, {duration: 1});
        }

        // #352 -> add pause
        if (PearlHarbor.canAddPauseInFS && !PearlHarbor.apiPlugin.settings.get(APISetting.FAST_SPIN, false) && PearlHarborHelper.isFreeSpin(PearlHarbor.model.data.mode) && PearlHarbor.model.data.nextMode !== PearlHarborGameMode.NORMAL) {
            tl.to(this, {duration: 1});
        }

        if (tl.duration() === 0) {
            tl.to(this, {duration: 0.001});
        }
        tl.add(() => flowStateController.finish());
    }

    public start(flowStateController: FlowStateController): void {
        SimplePresentationRunner.run(this._presentations, () => this.onComplete(flowStateController), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }
}